module.exports = __webpack_public_path__ + "img/graph2.6a5d265a.jpg";